import axios, {AxiosError} from "axios";
import { API_URL } from "../constant";
import { ErrorResponse } from "../constant";

export async function ResendConfirm(seqid: number, licenseNumber: string): Promise<ErrorResponse> {

    try {
        const token = localStorage.getItem("token")
        
        const config = {
            headers: {
              Authorization: `Bearer ${token}`, // Bearer token
            },
          };
      
        const requst = {
            seqID: seqid,
            licenseNumber: licenseNumber
        }

        const response = await axios.post(
          `${API_URL}api/filing_history/resendConfirmation`,
          requst,
          config
        );
    
        if (response.status === 204)
        {
            return { success: true, errorMsg: "The invoice and detailed filings have been sent to your email. Please check your inbox..."};
        }
        else if (response.status === 422)
        {
            return { success: false, errorMsg: "Validation Error" };
        }
        else{
            return { success: false, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, errorMsg: "No response received from server" };
        } else {
            return { success: false, errorMsg: `Error:, ${error.message}` };
        }
    }
}

export async function ResendDTRConfirm(dtrId: number): Promise<ErrorResponse> {

    try {
        const token = localStorage.getItem("token")
        
        const config = {
            headers: {
              Authorization: `Bearer ${token}`, // Bearer token
            },
          };
      
        const requst = {
            DTRID: dtrId
        }

        const response = await axios.post(
          `${API_URL}api/late/resend`,
          requst,
          config
        );
    
        if (response.status === 204)
        {
            return { success: true, errorMsg: "The delinquent transaction report have been sent to your email. Please check your inbox..."};
        }
        else if (response.status === 422)
        {
            return { success: false, errorMsg: "Validation Error" };
        }
        else{
            return { success: false, errorMsg: "Unexpected status code" };
        }
    } catch (err) {
        const error = err as AxiosError;
        if (error.response) {
            return { success: false, errorMsg: `"Server Error:"${error.response.status}` };
        } else if (error.request) {
            return { success: false, errorMsg: "No response received from server" };
        } else {
            return { success: false, errorMsg: `Error:, ${error.message}` };
        }
    }
}